module.exports = __webpack_public_path__ + "img/az.17c629a1.svg";